<mat-drawer-container autosize [ngClass]="{ 'container-closed': !isExpanded }">
  <mat-drawer #drawer class="drawer" mode="side" disableClose="true" opened="true">
    <div class="contents sidebar">
      <mat-nav-list>
        <mat-list-item [routerLink]="['/app/dashboard']" routerLinkActive="active" matTooltip="Dashboard"
          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <ng-icon name="heroSquares2x2"></ng-icon>
          <span *ngIf="isExpanded">Dashboard</span>
        </mat-list-item>

        <mat-list-item [routerLink]="['/app/contract']" routerLinkActive="active" matTooltip="Contracts"
          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <ng-icon name="heroClipboardDocument"></ng-icon>
          <span *ngIf="isExpanded">Contracts</span>
        </mat-list-item>

        <mat-list-item matTooltip="Users & Roles" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
          [matMenuTriggerFor]="users" (click)="openMenu()"
          *ngIf="userService.permissionsValue['_USER_MANAGEMENT_VIEW_']">
          <ng-icon name="heroUser"></ng-icon>
          <span *ngIf="isExpanded">Users & Roles</span>
        </mat-list-item>

        <mat-menu #users="matMenu" yPosition="below" xPosition="before" class="submenu">
          <mat-nav-list>
            <mat-list-item [routerLink]="['/app/user/list']" routerLinkActive="active" matTooltip="Users"
              [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroUsers"></ng-icon>
              <span>Users</span>
            </mat-list-item>

            <mat-list-item [routerLink]="['/app/role/list']" routerLinkActive="active" matTooltip="Roles & Permissions"
              [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroUserGroup"></ng-icon>
              <span>Roles & Permissions</span>
            </mat-list-item>
          </mat-nav-list>
        </mat-menu>

        <mat-list-item [routerLink]="['/app/report']" routerLinkActive="active" matTooltip="Reports"
          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <ng-icon name="heroClipboardDocumentList"></ng-icon>
          <span *ngIf="isExpanded">Reports</span>
        </mat-list-item>

        <mat-list-item matTooltip="Settings" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
          [matMenuTriggerFor]="settings" (click)="openMenu()"
          *ngIf="userService.permissionsValue['_CONTRACT_TYPE_VIEW_']">
          <ng-icon name="heroCog8Tooth"></ng-icon>
          <span *ngIf="isExpanded">Settings</span>
        </mat-list-item>

        <mat-menu #settings="matMenu" yPosition="below" xPosition="before" class="submenu">
          <mat-nav-list>
            <mat-list-item [routerLink]="['/app/notification']" routerLinkActive="active"
              matTooltip="Alert & Notifications" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroBellAlert"></ng-icon>
              <span>Alert & Notifications</span>
            </mat-list-item>

            <mat-list-item [routerLink]="['/app/contract-type']" routerLinkActive="active" matTooltip="Contract Type"
              [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroClipboardDocumentCheck"></ng-icon>
              <span>Contract Type</span>
            </mat-list-item>

            <mat-list-item [routerLink]="['/app/attributes']" routerLinkActive="active" matTooltip="Attributes"
              [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroCircleStack"></ng-icon>
              <span>Attributes</span>
            </mat-list-item>

            <mat-list-item [routerLink]="['/app/clause']" routerLinkActive="active" matTooltip="Clauses"
              [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroNewspaper"></ng-icon>
              <span>Clauses</span>
            </mat-list-item>

            <mat-list-item [routerLink]="['/app/contract-template']" routerLinkActive="active" matTooltip="Template"
              [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
              <ng-icon name="heroDocumentText"></ng-icon>
              <span>Template</span>
            </mat-list-item>

            <mat-list-item [routerLink]="['/app/account-master']" routerLinkActive="active" matTooltip="Account Master"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <ng-icon name="heroUser"></ng-icon>
            <span>Account Master</span>
          </mat-list-item>
          </mat-nav-list>
        </mat-menu>

        <mat-list-item [routerLink]="['/app/organisation/list']" routerLinkActive="active" matTooltip="Organisation"
          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <ng-icon name="heroGlobeAlt"></ng-icon>
          <span *ngIf="isExpanded">Organisation </span>
        </mat-list-item>
        <!-- <mat-list-item [routerLink]="['/app/search']" routerLinkActive="active" matTooltip="Search Result"
        [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
        <ng-icon name="heroMagnifyingGlassCircle"></ng-icon>
        <span *ngIf="isExpanded">Search Result</span>
      </mat-list-item> -->
      <mat-list-item [routerLink]="['/app/result']" routerLinkActive="active" matTooltip="Advanced Search"
      [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
      <ng-icon name="heroMagnifyingGlassCircle"></ng-icon>
      <span *ngIf="isExpanded">Advanced Search</span>
    </mat-list-item>

    <mat-list-item matTooltip="E-Signer" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
      [matMenuTriggerFor]="esigner" (click)="openMenu()">
      <ng-icon name="heroCheckBadge"></ng-icon>
      <span *ngIf="isExpanded">E-Signer</span>
    </mat-list-item>

    <mat-menu #esigner="matMenu" class="submenu">
      <mat-nav-list>
        <mat-list-item [routerLink]="['/app/em-signer']" routerLinkActive="active" matTooltip="Em-Signer"
          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <ng-icon name="heroDocumentText"></ng-icon>
          <span>Em-Signer</span>
        </mat-list-item>

        <mat-list-item [routerLink]="['/app/hello-sign']" routerLinkActive="active" matTooltip="Hello Sign"
          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <ng-icon name="heroDocumentPlus"></ng-icon>
          <span>Hello Sign</span>
        </mat-list-item>
      </mat-nav-list>
    </mat-menu>

        <div class="about w-100">
          <mat-list-item [routerLink]="['/app/about']" routerLinkActive="inactive" matTooltip="About"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <ng-icon name="heroInformationCircle"></ng-icon>
            <span *ngIf="isExpanded">About</span>
          </mat-list-item>

          <!-- <mat-list-item [routerLink]="['/app/help']" routerLinkActive="inactive" matTooltip="Help"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <ng-icon name="heroQuestionMarkCircle"></ng-icon>
            <span *ngIf="isExpanded">Help</span>
          </mat-list-item> -->
        </div>
      </mat-nav-list>
    </div>
  </mat-drawer>

  <mat-toolbar class="main header" [style.width]="getHeaderWidth()">
    <div class="logo">
      <span *ngIf="!isExpanded; else opened" (click)="isExpanded = !isExpanded" class="close">
        <ng-icon name="heroBars3BottomLeft"></ng-icon>
      </span>

      <ng-template #opened>
        <span class="close" (click)="isExpanded = !isExpanded">
          <ng-icon name="heroChevronDoubleLeft"></ng-icon>
        </span>
      </ng-template>
      <div *ngIf="userService.loggedInOrg">
        <a [title]="userService.loggedInOrg?.organizationName" id="menu" [routerLink]="['/app/dashboard']">
          <img
            [src]="getOrganizationLogo()"
            alt="[userService.loggedInOrg?.organizationName]" />
        </a>
      </div>
    </div>

    <div class="profile" [matMenuTriggerFor]="profile">
      <span>
        <img
          [src]="userService.loggedinUser.profilePic ? 'data:image/png;base64,'+userService.loggedinUser.profilePic : '/assets/img/img_avatar.png'"
          class="rounded-circle">{{ userService.loggedinUser.firstName + (userService.loggedinUser.middleName ?
        ' ' + userService.loggedinUser.middleName + ' ' : ' ') + userService.loggedinUser.lastName }}
      </span>
      <ng-icon name="heroChevronDown"></ng-icon>
    </div>
    <mat-menu #profile="matMenu" xPosition="before">
      <button mat-menu-item class="user-menu-button"
        [routerLink]="['/app/user/edit',userService.loggedinUser.id]"><ng-icon name="heroCog8Tooth"></ng-icon> Edit
        Profile</button>
      <button mat-menu-item class="user-menu-button" (click)="logout()"><ng-icon name="heroPower"></ng-icon>
        Logout</button>
    </mat-menu>
  </mat-toolbar>

  <div class="main contents">
    <router-outlet></router-outlet>
  </div>


  <mat-toolbar class="main footer" [style.width]="getFooterWidth()">
    <div>&copy; Copyright {{year}}. All rights reserved.</div>
  </mat-toolbar>
</mat-drawer-container>